import { TRANSPORT_LOCATIONS, TRANSPORT_LOCATİON_ITEM, TransportLocationTypes } from "@elit-hair/elitklinik-shared";
import { TbBuilding, TbBuildingAirport, TbMapPin } from "react-icons/tb";

import { CommonStatusItem } from "@/types/global";

import { softColors } from "./colors";

export type TransportLocationTypeItem = CommonStatusItem & {
    label: string;
    value: TransportLocationTypes;
};

export const transportLocationStyles: TransportLocationTypeItem[] = [
    {
        label: "Havalimanı",
        value: TransportLocationTypes.AIRPORT,
        component: () => TbBuildingAirport,
        ...softColors.indigo,
        tooltip: {
            title: "Havalimanı",
            description: "İstanbul havalimanları (IST, SAW)",
        },
    },
    {
        label: "İlçe",
        value: TransportLocationTypes.DISTRICT,
        component: () => TbMapPin,
        ...softColors.purple,
        tooltip: {
            title: "İlçe",
            description: "İstanbul ilçeleri ve bölgeleri",
        },
    },
    {
        label: "Bina",
        value: TransportLocationTypes.BUILDING,
        component: () => TbBuilding,
        ...softColors.green,
        tooltip: {
            title: "Bina",
            description: "Klinik, otel ve diğer spesifik lokasyonlar",
        },
    },
];

export const getTransportLocationTypeLabel = (option: TRANSPORT_LOCATİON_ITEM) => {
    const typeStyle = transportLocationStyles.find((style) => style.value === option.type);
    return typeStyle?.label || "";
};

// Helper functions to find locations
export const findLocationByValue = (value: number | string) =>
    TRANSPORT_LOCATIONS.find((location) => location.value === value);
export const isAirportLocation = (value: number | string) =>
    TRANSPORT_LOCATIONS.find((location) => location.value === value)?.type === TransportLocationTypes.AIRPORT;
